import axiosInstance from "../utils/axiosInstance";


export const registerNextOfKinApi = async (dataToSubmit) => {
    const urlToUse = `/auth/register/patient?type=nextofkin&userId=${localStorage.getItem('userId')}`;
    return await axiosInstance.post(urlToUse, dataToSubmit)
}
export const registerBioDataApi = async (dataToSubmit) => {
    const body = new FormData();
    Object.entries(dataToSubmit).forEach(([key, value]) => {
        if (key !== 'profileImage' && key !== 'image' && value !== undefined && value !== null) body.append(key, value);
    });
    body.append('file', dataToSubmit.profileImage);
    return await axiosInstance.post('/auth/register/patient?type=biodata', body, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};
export const registerWorkerApi = async (values) => {
    const body = new FormData();
    Object.entries(values).forEach(([key, value]) => {
        if (key !== 'profileImage' && key !== 'confirmPassword') body.append(key, value);
    });
    body.append('file', values.profileImage);
    return await axiosInstance.post('/auth/register/worker', body, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};
export const loginApi = async (values) => await axiosInstance.post('/auth/login', values)
export const forgotPasswordApi = async (values) =>
    await axiosInstance.post('/auth/forgot-password', values);
export const validateResetTokenApi = async (token) =>
    await axiosInstance.post('/auth/validate-reset-token', { token });
export const resetPasswordApi = async (values) =>
    await axiosInstance.post('/auth/reset-password', values);
export const heartbeatApi = async () =>
    await axiosInstance.post('/auth/heartbeat');
export const logoutApi = async () =>
    await axiosInstance.post('/auth/logout');
